import React from 'react';
import { Box, TextField } from '@mui/material';

const LimitSelector = ({ 
  limitValue, 
  onLimitValueChange,
  error 
}) => {
  const handleLimitChange = (event) => {
    onLimitValueChange(event.target.value);
  };

  return (
    <Box>
      <TextField
        value={limitValue || ''}
        onChange={handleLimitChange}
        placeholder="Enter number of rows"
        type="number"
        size="small"
        error={Boolean(error)}
        helperText={error}
        inputProps={{ min: 1 }}
        sx={{ width: 200 }}
      />
    </Box>
  );
};

export default LimitSelector; 